import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { selectFlow } from '../store/app';

export const useNextPageName = (skipCount = 0) => {
  const location = useLocation();
  const current = location.pathname;
  const flow = useSelector(selectFlow);

  return flow ? flow[flow.indexOf(current.replace('/', '')) + 1 + skipCount] : null;
};
